import { EncryptedWalletRequest, TokenResponse, TransactionAmountType } from '../models';
import { tokenizationApi } from '../api';
import { WalletResponse } from 'services/checkout-service/models';

const createCloverWalletToken = (event: ApplePayJS.ApplePayPaymentAuthorizedEvent) => {
  const { token: { paymentData: applePayPaymentData }, billingContact } = event.payment;
  const { addressLines = [], postalCode, givenName, familyName } = billingContact || {};

  const encryptedWallet: EncryptedWalletRequest = {
    applePayPaymentData,
    transactionAmountType: TransactionAmountType.ESTIMATED,
    name: `${givenName} ${familyName}`,
    ...(addressLines.length > 0 && { address_line1: addressLines[0] }),
    ...(postalCode !== undefined && { address_zip: postalCode }),
  };

  return tokenizationApi.post<TokenResponse>(
    'v1/tokens',
    { encryptedWallet }
  );
};

export const makeApplePayCToken = async (
  event: ApplePayJS.ApplePayPaymentAuthorizedEvent
) => {
  const {
    id
  } = await createCloverWalletToken(event);

  return {
    token: id,
  } as WalletResponse;
};
